/* eslint-disable max-len */
import React from 'react';
import { SvgProps, IconType } from '../../types/types';

export const Rotation: IconType = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 39H41"
        stroke="#D8D9F8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <rect
        x="4"
        y="10"
        width="40"
        height="28"
        rx="4"
        stroke="#7D7FE8"
        strokeWidth="2"
      />
      <path
        d="M10 16V31.5"
        stroke="#7D7FE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M10 25L10 28"
        stroke="#D8D9F8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M17 16V31.5"
        stroke="#7D7FE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M23 16V31.5"
        stroke="#7D7FE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M29 16V31.5"
        stroke="#7D7FE8"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17 18L17 21"
        stroke="#D8D9F8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M23 21L23 24"
        stroke="#D8D9F8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M29 25L29 28"
        stroke="#D8D9F8"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M38 26.1132L35.1132 29L38 31.8868L40.8868 29L38 26.1132ZM37.5 31C37.5 31.2761 37.7239 31.5 38 31.5C38.2761 31.5 38.5 31.2761 38.5 31L37.5 31ZM38 29L37.5 29L37.5 31L38 31L38.5 31L38.5 29L38 29Z"
        fill="#B1B2F1"
      />
      <path
        d="M38 20.1132L35.1132 23L38 25.8868L40.8868 23L38 20.1132ZM37.5 25C37.5 25.2761 37.7239 25.5 38 25.5C38.2761 25.5 38.5 25.2761 38.5 25L37.5 25ZM38 23L37.5 23L37.5 25L38 25L38.5 25L38.5 23L38 23Z"
        fill="#B1B2F1"
      />
      <circle cx="40.0336" cy="12.7001" r="6.6" fill="white" />
      <path
        d="M39.6673 16C39.8751 16 40.0494 15.9296 40.1902 15.7888C40.3305 15.6485 40.4007 15.4744 40.4007 15.2667V13.0667H42.619C42.8268 13.0667 42.9979 12.9963 43.1323 12.8555C43.2668 12.7152 43.334 12.5411 43.334 12.3333C43.334 12.1256 43.2636 11.9513 43.1228 11.8105C42.9825 11.6702 42.8084 11.6 42.6007 11.6H40.4007V9.38167C40.4007 9.17389 40.3305 9.00278 40.1902 8.86833C40.0494 8.73389 39.8751 8.66667 39.6673 8.66667C39.4595 8.66667 39.2855 8.73682 39.1452 8.87713C39.0044 9.01793 38.934 9.19222 38.934 9.4V11.6H36.7157C36.5079 11.6 36.3368 11.6702 36.2023 11.8105C36.0679 11.9513 36.0007 12.1256 36.0007 12.3333C36.0007 12.5411 36.0708 12.7152 36.2111 12.8555C36.3519 12.9963 36.5262 13.0667 36.734 13.0667H38.934V15.285C38.934 15.4928 39.0044 15.6639 39.1452 15.7983C39.2855 15.9328 39.4595 16 39.6673 16ZM39.6673 19.6667C38.6529 19.6667 37.6995 19.474 36.8073 19.0888C35.9151 18.704 35.139 18.1817 34.479 17.5217C33.819 16.8617 33.2966 16.0856 32.9119 15.1933C32.5266 14.3011 32.334 13.3478 32.334 12.3333C32.334 11.3189 32.5266 10.3656 32.9119 9.47333C33.2966 8.58111 33.819 7.805 34.479 7.145C35.139 6.485 35.9151 5.96238 36.8073 5.57713C37.6995 5.19238 38.6529 5 39.6673 5C40.6818 5 41.6351 5.19238 42.5273 5.57713C43.4195 5.96238 44.1957 6.485 44.8557 7.145C45.5157 7.805 46.038 8.58111 46.4228 9.47333C46.808 10.3656 47.0007 11.3189 47.0007 12.3333C47.0007 13.3478 46.808 14.3011 46.4228 15.1933C46.038 16.0856 45.5157 16.8617 44.8557 17.5217C44.1957 18.1817 43.4195 18.704 42.5273 19.0888C41.6351 19.474 40.6818 19.6667 39.6673 19.6667ZM39.6673 18.2C41.2929 18.2 42.6772 17.6287 43.8202 16.4862C44.9627 15.3432 45.534 13.9589 45.534 12.3333C45.534 10.7078 44.9627 9.32349 43.8202 8.18047C42.6772 7.03793 41.2929 6.46667 39.6673 6.46667C38.0418 6.46667 36.6577 7.03793 35.5152 8.18047C34.3722 9.32349 33.8007 10.7078 33.8007 12.3333C33.8007 13.9589 34.3722 15.3432 35.5152 16.4862C36.6577 17.6287 38.0418 18.2 39.6673 18.2Z"
        fill="#57B968"
      />
    </svg>
  );
};
